import { JarvisStatus } from "shared/constants";

export const getJarvisBadgeStatus = (status: JarvisStatus) => {
    let badgeStatus: string = "";
    switch (status) {
        case JarvisStatus.OK:
            badgeStatus = "confirm";
            break;
        case JarvisStatus.KO:
            badgeStatus = "error";
            break;
        case JarvisStatus.PENDING:
            badgeStatus = "warning";
            break;
        default:
            badgeStatus = "error";
            break;
    }
    return badgeStatus;
}